import React, { useContext, useState } from 'react'
import moment from 'moment'
import Alert from '@mui/material/Alert'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { UserContext } from '../../App'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import ExpandMore from '@mui/icons-material/ExpandMore'
import ShiftLine from './ShiftLine'

const MyUpcomingShifts = ({
  shifts,
  setOpenShift,
  acknowledgeShift,
  declineShift,
}) => {
  const { user } = useContext(UserContext)
  const [expanded, setExpanded] = useState(true)
  return (
    <Stack gap={1}>
      <Accordion expanded={expanded} disableGutters component={Paper} variant="outlined" sx={{ borderRadius: 2, '&:before': { display: 'none' } }}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          sx={{ display: 'flex' }}
          onClick={() => setExpanded(!expanded)}
        >
          <Typography variant="title2">My Upcoming Shifts</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>
          {shifts.length === 0 && (
            <Alert severity="info">You have no upcoming shifts.</Alert>
          )}
          {shifts
            .sort((a, b) => moment(a.start) - moment(b.start))
            .map((shift) => (
              <ShiftLine
                key={shift._id}
                shift={shift}
                onClick={() => setOpenShift(shift)}
                acknowledgeShift={acknowledgeShift}
                declineShift={declineShift}
              />
            ))}
        </AccordionDetails>
      </Accordion>
    </Stack>
  )
}

export default MyUpcomingShifts
